import { useTranslation } from 'react-i18next';
import Text from '../../../../shared/Text';

export const UserCreated = ({ name }) => {
  const { t } = useTranslation('users');

  return (
    <>
      <Text variant="body3">{t('userCreated.success', { name })}</Text>
    </>
  );
};
